// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Actions
import * as EditAccidentActions from '@accidents/store/actions/edit-accident.actions';

export interface AccidentEditState {
  loadingEditAccident: boolean;
  loadingRetrySubmitSAPClaimants: boolean;
}

export const initialAccidentEditState: AccidentEditState = {
  loadingEditAccident: false,
  loadingRetrySubmitSAPClaimants: false,
};

const AccidentEditReducer = createReducer(
  initialAccidentEditState,
  on(EditAccidentActions.reset, () => initialAccidentEditState),
  on(EditAccidentActions.editAccidentRequested, state => ({
    ...state,
    loadingEditAccident: true,
  })),
  on(EditAccidentActions.editAccidentResponse, state => ({
    ...state,
    loadingEditAccident: false,
  })),
  on(EditAccidentActions.retrySubmitSAPClaimantsRequested, state => ({
    ...state,
    loadingRetrySubmitSAPClaimants: true,
  })),
  on(EditAccidentActions.retrySubmitSAPClaimantsResponse, state => ({
    ...state,
    loadingRetrySubmitSAPClaimants: false,
  }))
);

export function reducer(
  state: AccidentEditState | undefined,
  action: Action
): AccidentEditState {
  return AccidentEditReducer(state, action);
}
